<template>
  <div v-if="enabled">
    <q-btn-dropdown :label="currentLanguage.label"
                    auto-close
                    class="q-mr-xs q-pa-sm text-primary animated-glow"
                    :class="color ? 'text-' + color : ''"
                    flat>
      <q-list>
        <q-item :key="lang.name" @click="changeLanguage(lang.name)" clickable v-for="lang in $i18n.languages">
          <q-item-section>
            <q-item-label>
              {{ lang.label }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-btn-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LanguageSelector',
  props: {
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  data () {
    return {
      enabled: process.env.MULTILINGUAL,
      currentLanguage: {}
    }
  },
  watch: {
    currentLanguage (lang) {
      import(
        /* webpackInclude: /(fa-ir|ar|tr|en-us)\.js$/ */
        'quasar/lang/' + lang.isoName
      ).then(lang => {
        this.$q.lang.set(lang.default)
      })
    }
  },
  methods: {
    ...mapActions(['set_lang']),
    changeLanguage (lang) {
      this.setLanguage(lang)
      this.$emit('set', { lang: lang })
    },
    setLanguage (lang) {
      this.set_lang(lang)
      this.currentLanguage = this.$i18n.languages.find(item => item.name === lang)
      this.$i18n.locale = lang
      this.$q.lang.rtl = this.currentLanguage.rtl

      document.dir = this.currentLanguage.rtl ? 'rtl' : 'ltr'
      document.lang = this.currentLanguage.name
      document.title = this.$t('site_title')
    }
  },
  mounted () {
    this.setLanguage(this.lang)
  }
}
</script>

<style scoped>

</style>
